export const computeInitials = (borrowerData: any, user: any): string => {
    const primaryName = borrowerData?.name || user?.name || '';
    const primaryLastName = borrowerData?.lastName || user?.lastName || '';
    const hasPrimaryNames = Boolean(primaryName || primaryLastName);

    if (hasPrimaryNames) {
      const first = primaryName ? primaryName.charAt(0) : '';
      const last = primaryLastName ? primaryLastName.charAt(0) : '';
      const combined = `${first}${last}`.trim().toUpperCase();
      if (combined.length > 0) {
        return combined;
      }
    }

    const fallbackEmail = borrowerData?.email || user?.email || '';
    if (fallbackEmail) {
      return fallbackEmail.slice(0, 2).toUpperCase();
    }

    return 'CL';
  };